"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _luxon = require("luxon");

var _max = _interopRequireDefault(require("lodash/max"));

var _colors = require("./colors");

var _chartUtils = require("../../chartUtils");

var _helpers = require("../../helpers");

var _Styles = require("./Styles");

var _ScrollableXYPlot = _interopRequireDefault(require("./ScrollableXYPlot"));

var _CustomerHint = _interopRequireDefault(require("./CustomerHint"));

var _chartDataTypes = require("../../constants/chartDataTypes");

var _CustomerDisplay = _interopRequireDefault(require("./CustomerDisplay"));

var _CustomerInteraction = _interopRequireDefault(require("./CustomerInteraction"));

var _CustomerLegend = _interopRequireDefault(require("./CustomerLegend"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

/* eslint-disable no-param-reassign */
var CustomerYearlyChart = function CustomerYearlyChart(_ref) {
  var chartType = _ref.chartType,
      siteProductionYearlyReadings = _ref.siteProductionYearlyReadings,
      contractGenerationsYearlyReadings = _ref.contractGenerationsYearlyReadings,
      startDate = _ref.startDate,
      endDate = _ref.endDate,
      zone = _ref.zone,
      enabledDataTypes = _ref.enabledDataTypes,
      mobileWidth = _ref.mobileWidth,
      desktopWidth = _ref.desktopWidth,
      children = _ref.children;

  var luxonStartDate = _luxon.DateTime.fromISO(startDate, {
    zone: zone
  });

  var luxonEndDate = _luxon.DateTime.fromISO(endDate, {
    zone: zone
  });

  var hasProduction = enabledDataTypes.indexOf(_chartDataTypes.PRODUCTION) > -1;
  var hasConsumption = enabledDataTypes.indexOf(_chartDataTypes.CONSUMPTION) > -1;
  var hasExpected = enabledDataTypes.indexOf(_chartDataTypes.EXPECTED) > -1;
  var readingDictionary = siteProductionYearlyReadings.reduce(function (dictionary, reading) {
    var id = _luxon.DateTime.fromISO(reading.readingEndTimeLocal, {
      zone: zone
    }).endOf('year').toISODate();

    dictionary[id] = reading;
    return dictionary;
  }, {});
  var expectedDictionary = hasExpected && contractGenerationsYearlyReadings.reduce(function (dictionary, reading) {
    var id = _luxon.DateTime.fromISO(reading.date, {
      zone: zone
    }).endOf('year').toISODate();

    dictionary[id] = reading;
    return dictionary;
  }, {});
  var lastDayOfEachYear = (0, _helpers.getDatesBetween)({
    startDate: luxonStartDate,
    endDate: luxonEndDate
  }, {
    hour: 23,
    minute: 59,
    second: 59
  }, 'years');
  var groupedCoordinates = [];
  var productionCoordinates = [];
  var consumptionCoordinates = [];
  var expectedCoordinates = [];
  lastDayOfEachYear.forEach(function (dt) {
    var isoDate = dt.endOf('year').toISODate();
    var y = readingDictionary[isoDate] && (0, _chartUtils.isNumeric)(readingDictionary[isoDate].deliveredKwh) ? Number(readingDictionary[isoDate].deliveredKwh) : 0;
    var expectedY = expectedDictionary[isoDate] && (0, _chartUtils.isNumeric)(expectedDictionary[isoDate].gen) ? Number(expectedDictionary[isoDate].gen) : 0;
    var productionCoordinate = {
      x: isoDate,
      y: hasProduction ? y : 0,
      y0: 0,
      color: _colors.START_GRADIENT,
      name: 'Production'
    };
    var consumptionY = 0;

    if (readingDictionary[isoDate] && (0, _chartUtils.isNumeric)(readingDictionary[isoDate].estimatedConsumptionKwh)) {
      consumptionY = Number(readingDictionary[isoDate].estimatedConsumptionKwh);
    } else if (readingDictionary[isoDate] && (0, _chartUtils.isNumeric)(readingDictionary[isoDate].consumptionKwh)) {
      consumptionY = Number(readingDictionary[isoDate].consumptionKwh);
    }

    var consumptionCoordinate = {
      x: isoDate,
      y: hasConsumption ? consumptionY : 0,
      y0: 0,
      color: _colors.CUSTOMER_CONSUMPTION,
      name: 'Consumption'
    };
    var expectedCoordinate = {
      x: isoDate,
      y: hasExpected ? expectedY : 0,
      y0: 0,
      icon: _Styles.ExpectedIcon,
      name: 'Estimated Production'
    };
    var groupedCoordinate = {
      x: isoDate,
      y: 0,
      y0: 0,
      coordinates: []
    };

    if (hasProduction) {
      groupedCoordinate.coordinates.push(productionCoordinate);
    }

    if (hasConsumption) {
      groupedCoordinate.coordinates.push(consumptionCoordinate);
    }

    if (hasExpected) {
      groupedCoordinate.coordinates.push(expectedCoordinate);
    }

    productionCoordinates.push(productionCoordinate);
    consumptionCoordinates.push(consumptionCoordinate);
    expectedCoordinates.push(expectedCoordinate);
    groupedCoordinates.push(groupedCoordinate);
  });
  var maxAggregation = productionCoordinates.concat(consumptionCoordinates, expectedCoordinates);
  var maxValue = (0, _max["default"])(maxAggregation.map(function (c) {
    return c.y;
  }));
  var hasNoData = Object.keys(readingDictionary).length === 0;
  var roundedMaxValue = Math.max(Math.ceil(maxValue / 5) * 5, 5);
  var tickValues = (0, _helpers.getTickValuesFromMax)(roundedMaxValue);
  var widths = {
    mobile: mobileWidth ? mobileWidth : '2000px',
    desktop: desktopWidth ? desktopWidth : '1600px'
  };
  return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_ScrollableXYPlot["default"], {
    isBattery: false,
    hasNoData: hasNoData,
    roundedMaxValue: roundedMaxValue,
    tickValues: tickValues,
    widths: widths
  }, /*#__PURE__*/_react["default"].createElement(_CustomerDisplay["default"], {
    roundedMaxValue: roundedMaxValue,
    tickValues: tickValues,
    productionCoordinates: productionCoordinates,
    consumptionCoordinates: consumptionCoordinates,
    expectedCoordinates: expectedCoordinates,
    chartType: chartType,
    enabledDataTypes: enabledDataTypes,
    hasNoData: hasNoData,
    zone: zone,
    widths: widths,
    renderXAxisTick: function renderXAxisTick(isoDate) {
      return _luxon.DateTime.fromISO(isoDate, {
        zone: zone
      }).toFormat('yyyy');
    }
  }), /*#__PURE__*/_react["default"].createElement(_CustomerInteraction["default"], {
    chartType: chartType,
    timeZone: zone,
    widths: widths,
    groupedCoordinates: groupedCoordinates,
    roundedMaxValue: roundedMaxValue,
    renderHint: function renderHint(selectedCoordinate) {
      return /*#__PURE__*/_react["default"].createElement(_CustomerHint["default"], {
        selectedCoordinate: selectedCoordinate,
        zone: zone,
        dateFormat: "yyyy"
      });
    }
  }), hasNoData && children && /*#__PURE__*/_react["default"].createElement(_Styles.FillAvailableSpace, null, children)), /*#__PURE__*/_react["default"].createElement(_CustomerLegend["default"], {
    enabledDataTypes: enabledDataTypes
  }));
};

CustomerYearlyChart.propTypes = {
  chartType: _propTypes["default"].oneOf(['Line', 'Bar']),
  siteProductionYearlyReadings: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    deliveredKwh: _propTypes["default"].string,
    readingEndTimeLocal: _propTypes["default"].string
  })),
  contractGenerationsYearlyReadings: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    date: _propTypes["default"].string,
    gen: _propTypes["default"].number
  })),
  startDate: _propTypes["default"].string.isRequired,
  endDate: _propTypes["default"].string.isRequired,
  zone: _propTypes["default"].string,
  mobileWidth: _propTypes["default"].string,
  desktopWidth: _propTypes["default"].string,
  enabledDataTypes: _propTypes["default"].arrayOf(_propTypes["default"].string),
  children: _propTypes["default"].node
};
CustomerYearlyChart.defaultProps = {
  chartType: 'Bar',
  renderHint: undefined,
  siteProductionYearlyReadings: [],
  zone: 'local',
  mobileWidth: '500px',
  desktopWidth: '700px',
  enabledDataTypes: ['production'],
  contractGenerationsYearlyReadings: [],
  children: null
};
var _default = CustomerYearlyChart;
exports["default"] = _default;